import API from "./api";

// GET
export const getUsers = () =>
    API.get("/Users");

// ADD
export const addUser = (data) =>
    API.post("/Users", data);

// UPDATE
export const updateUser = (id, data) =>
    API.put(`/Users/${id}`, data);

// DELETE
export const deleteUser = (id) =>
    API.delete(`/Users/${id}`);